import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Slider from 'react-slick';
import { settings } from '../DealSlider/DealSlider';
import Product from './Product';

// Driven either by an admin-managed ProductSection (pass sectionId, and
// "View All" links to /products?section=<id>) or by a direct viewAllUrl
// override (used by ProductDetails.jsx's "Similar Products"/"More from
// this brand" sliders, which aren't backed by a stored section).
const ProductSlider = ({ title, tagline, products, sectionId, viewAllUrl }) => {

    if (!products || products.length === 0) return null;

    const resolvedViewAllUrl = viewAllUrl || (sectionId ? `/products?section=${sectionId}` : "/products");

    return (
        <section className="bg-white w-full rounded-lg shadow-sm overflow-hidden">
            <div className="flex px-6 py-4 justify-between items-center">
                <div className="title flex flex-col gap-0.5">
                    <h1 className="text-lg font-bold uppercase tracking-wide text-gray-800">{title}</h1>
                    <p className="text-sm text-gray-400">{tagline}</p>
                </div>
                <Link to={resolvedViewAllUrl} className="flex items-center gap-1 bg-white border text-xs font-medium text-gray-700 px-4 py-2 rounded-full hover:border-primary-blue hover:text-primary-blue">
                    View All
                    <ArrowForwardIcon sx={{ fontSize: "14px" }} />
                </Link>
            </div>
            <hr />
            <div className="relative px-4 sm:px-8">
                <Slider {...settings} className="flex items-center justify-between p-1">
                    {products.map((product) => (
                        <Product {...product} key={product._id} />
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default ProductSlider;